import * as angular from 'angular';
import {react2angular} from "react2angular";

import {ContractAssociations} from './component/ContractAssociations';

const ngModule = angular.module('dataforvalter.contract-associations', [])
    .component('reactAssociations',
               react2angular(ContractAssociations, [],
                             ['$routeParams', 'server', 'security', 'contract', 'nvdbapi', 'datacatalog']));
const contractAssociationsModuleName = ngModule.name;
export default contractAssociationsModuleName;
